import anime from 'animejs';

const PartnersAnimation = () => {
  const tl = anime.timeline({
    easing: 'easeInOutQuart',
    loop: true,
  });

  const categories = Array.from(document.querySelectorAll('.partner-category'));

  categories.map(category => {
    const groupId = `partner-group-${category.getAttribute('data-group')}`;
    const group = document.getElementById(groupId);

    category.style.setProperty('display', 'none');
    group.style.setProperty('display', 'none');

    return tl.add({
      targets: [category, group],
      keyframes: [
        {
          opacity: [0, 1],
          duration: 1000,
        },
        { opacity: 0, delay: 1000, duration: 1000 },
      ],
      changeBegin: anim => {
        anim.animatables.map(a =>
          a.target.style.setProperty('display', 'inline-block')
        );
      },
      changeComplete: anim => {
        anim.animatables.map(a =>
          a.target.style.setProperty('display', 'none')
        );
      },
    });
  });
};

export default PartnersAnimation;



// WEBPACK FOOTER //
// ./src/scripts/modules/PartnersAnimation/index.js